import {
  doc,
  setDoc,
  collection,
  query,
  where,
  getDocs
} from "firebase/firestore";
import { db } from "../firebase";
import Cookies from "js-cookie";
import { Randomcode } from "../components_root/rendom_code";

export const Save_products_edit = async (data) => {
  const {title,uid,description,keywords } = data || {};

  // 1. Validate inputs
  if (!uid?.trim()) return { success: false, error: "Missing uid." };
  if (!title?.trim()) return { success: false, error: "Missing title" };
  if (!description?.trim()) return { success: false, error: "Missing description 2" };
  if (!keywords?.trim()) return { success: false, error: "Missing keywords." };
 

  const sessiontoken = Cookies.get("sessiontoken");
  const guid = Cookies.get("guid");
  const companyuid = Cookies.get("select_company_uid");

  if (!sessiontoken || sessiontoken === "undefined")
    return { success: false, error: "Session expired. Please relogin." };
  if (!guid || guid === "undefined")
    return { success: false, error: "Login expired. Please relogin." };
  if (!companyuid || companyuid === "undefined")
    return { success: false, error: "Please select company." };

  try {
    const tablename = "products";

    // Check if the same category + subcategory + item exists
    const productQuery = query(
      collection(db, tablename),
      where("guid", "==", guid), 
        where("companyuid", "==", companyuid), 
        where("uid", "==", uid), 
    );
    const productSnap = await getDocs(productQuery);

    if (productSnap.empty) {
      // Product not exists
      return { success: false, error: "This product not exists." };
    }

    // Product doesn't exist, create new
        const slug = keywords
  .toLowerCase()
  .replace(/[^a-z0-9\s]/g, "")
  .trim()
  .replace(/\s+/g, "-")
  .substring(0, 50);

    const savedata = {
      ...data,
      uid,      
      guid,
      companyuid,
      sessiontoken, 
   date_time_update: new Date(),
    };

    const productRef = doc(collection(db, tablename), uid);
    await setDoc(productRef, savedata,{merge:true});

    return { success: true, dockuid: uid, message: "Product saved successfully." };

  } catch (err) {
    console.error("❌ Error saving document:", err);
    return { success: false, error: err.message || "Unknown error" };
  }
};
